import { app } from '../../../../app';

app.component('companyApplicationUsageReport', {
    bindings: {
        companyApplications: '<',
        computersCustomApplications: '<',
        computersProtectionApplications: '<',
    },
    templateUrl: require('./application-usage-report.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/application-usage-report/application-usage-report.component.js